import useSWR from "swr";

import { fetcherThroughAuthProxy } from "~/endpoints/utils";

export interface Entitlement {
  name: string;
  quantity: number;
}

export interface BillingEntity {
  id: string;
  customerDid: string;
  status: string;
  entitlements?: Entitlement[];
}

/**
 * Get the billing entity for a VASP
 * @param vaspDID - VASP DID
 * @returns - Billing entity
 */
export const useBillingEntity = (vaspDID: string) => {
  const url = `/tf/vasps/${vaspDID}/billing/entity`;
  const { data, error, mutate } = useSWR<BillingEntity>(url, fetcherThroughAuthProxy, {
    refreshInterval: 0,
  });

  return {
    data,
    mutate,
    isLoading: !error && !data,
    error,
  };
};
